export default __webpack_public_path__ + "static/media/consultorDark.f767bd6a.svg";